import { cn } from '@/lib/utils'
import { ChangeEvent } from 'react'

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const
export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number]

interface TableSettingsProps {
  pageSize: number
  onPageSizeChange: (pageSize: PageSizeOption) => void
}

interface PageSizeSelectProps {
  id: string
  value: number
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
  className?: string
  showRowsLabel?: boolean
}

function PageSizeSelect({
  id,
  value,
  onChange,
  className,
  showRowsLabel = false,
}: PageSizeSelectProps) {
  return (
    <select
      id={id}
      value={value}
      onChange={onChange}
      className={cn(
        'block w-full rounded-md border border-border text-text shadow-xs focus:outline-hidden focus:ring-1 focus:ring-accent sm:text-sm',
        className,
      )}
    >
      {PAGE_SIZE_OPTIONS.map((option) => (
        <option key={option} value={option}>
          {option}
          {showRowsLabel ? ' rows' : ''}
        </option>
      ))}
    </select>
  )
}

export default function Settings({
  pageSize,
  onPageSizeChange,
}: TableSettingsProps) {
  return (
    <div className="flex items-center gap-2">
      {/* Footer wrapper sets font-mono + uppercase; explicitly opt out for this
          label since the design wants a quiet sans "Rows" beside the select. */}
      <span className="text-text-dim whitespace-nowrap font-sans text-sm normal-case tracking-normal">
        Rows
      </span>
      <div className="w-[72px]">
        <PageSizeSelect
          id="page-size-select"
          value={pageSize}
          onChange={(e) =>
            onPageSizeChange(Number(e.target.value) as PageSizeOption)
          }
          className="bg-panel-2 border-border-strong text-text h-7 rounded-sm py-0 pl-2 pr-7 font-sans normal-case tracking-normal"
        />
      </div>
    </div>
  )
}
